// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J7VB","fullView":"styles_fullView__KCsqq"};